/* Load the interactive map when it approaches the viewport, preserving the
   address and directions link as immediately usable content. */
class DeferredMap extends HTMLElement {
  connectedCallback() {
    const frame = this.querySelector('iframe[data-map-src]');
    if (!frame || frame.hasAttribute('src')) return;
    const load = () => {
      frame.src = frame.dataset.mapSrc;
      this.observer?.disconnect();
    };
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
      load();
      return;
    }
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) load();
    }, { rootMargin: '250px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('deferred-map')) {
  customElements.define('deferred-map', DeferredMap);
}
